import { playbackEnabledBlock } from '../utils/playbackUtils/playbackEnabledBlock.js'

/**
 * Global playback functionality.
 *
 * Targets any main container element with the class `js-has-playback`
 * and uses playback behavior (inline and modal) for supported media
 * types (video and iframe) contained within that block.
 *
 * The trigger element is expected to live inside the same container
 * as the hidden playback content.
 *
 * Refer to `LargeMediaBlock` for set up.
 */
const playbackTrigger = () => {
    const triggers = [...document.querySelectorAll('.js-has-playback')]
    if (!triggers.length > 0) return
    playbackEnabledBlock(triggers)
}
playbackTrigger()
